import Param from '../../param';

const param = new Param();

export default class YoutubeManager {
    constructor(){

        this.player;

        this.width = $("#"+param.youtube.domID).innerWidth();
        this.height = $("#"+param.youtube.domID).innerHeight();

        this.status = {
            load : false,
            play : false,
            pause : true
        }

    }
    init(){

        let _this = this;

        this.player = new YT.Player(param.youtube.domID, {
            width: this.width,
            height: this.height,
            videoId: param.youtube.id,
            playerVars: {
                'autoplay' : 1,
                'html5': 1,
                'modestbranding': 1,
                'controls':0,
                'rel':0,
                'enablejsapi':1,
                'showinfo':0
            },
            events: {
                'onReady': _this.onPlayerReady,
                'onStateChange': _this.onPlayerStateChange
            }
        });
        // this.player.playVideo();

    }

    onPlayerReady() {

    }
    onPlayerStateChange(event) {
        // 現在のプレーヤーの状態を取得

        var ytStatus = event.data;
        // 再生終了したとき
        if (ytStatus == YT.PlayerState.ENDED) {
            $(".l-modal").click();
        }
        // 再生中のとき
        if (ytStatus == YT.PlayerState.PLAYING) {
        }
        // 停止中のとき
        if (ytStatus == YT.PlayerState.PAUSED) {
            $(".l-modal").click();
        }
        // バッファリング中のとき
        if (ytStatus == YT.PlayerState.BUFFERING) {
        }
        // 頭出し済みのとき
        if (ytStatus == YT.PlayerState.CUED) {
        }
    }


    resize(){

        if($("#"+param.youtube.domID)[0]){
            this.width = $("#"+param.youtube.domID).innerWidth();
            this.height = $("#"+param.youtube.domID).innerHeight();
        }



    }


}